import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/mainPage.vue'),
  },
  {
    path: '/download',
    redirect: to => {
      // 方法接收目标路由作为参数
      // return 重定向的字符串路径/路径对象
      return { path: '/', query: { region: to.query.region } };
    },
  },
  // {
  //   path:'*',
  //   redirect: to => {
  //     // 方法接收目标路由作为参数
  //     // return 重定向的字符串路径/路径对象
  //     return { path: '/', query: { q: to.params.searchText } }
  //   }
  // }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
